import React from 'react'
import { Button } from 'react-bootstrap'
import './contact.scss'

class ContactComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
        }
    }
    onClick = () => {
        this.setState({ isOpen: !this.state.isOpen })
    }
    render() {
        const { isOpen } = this.state
        return <div className="Contact-component">
            <Button onClick={this.onClick}>
                Contact Us
                <span className={`arrow-icon ${isOpen && 'reverse'}`} />
            </Button>
        </div>
    }
}

export default ContactComponent



// WEBPACK FOOTER //
// ./src/components/footer/contact/ContactComponent.js